module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-24.e5a61862.png";